import * as React from 'react';

import { TailwindCard } from '../../../tailwind';
import { cn } from '../../../tailwind/utils';

const NewAdditionsCard = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <TailwindCard
    className={cn('flex flex-row p-5 items-center gap-3', className)}
    {...props}
  />
);
NewAdditionsCard.displayName = 'NewAdditionsCard';

const NewAdditionsCardTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p ref={ref} className={cn('text-base font-bold', className)} {...props} />
));
NewAdditionsCardTitle.displayName = 'NewAdditionsCardTitle';

const NewAdditionsCardSubtitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('text-sm text-text-subCopy', className)}
    {...props}
  />
));
NewAdditionsCardSubtitle.displayName = 'NewAdditionsCardSubtitle';

export { NewAdditionsCard, NewAdditionsCardTitle, NewAdditionsCardSubtitle };
